const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 17 16",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6300_15687",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 16,
    height: 16,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6300_15687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93714 13.3334H11.3988V11.3334C11.3988 10.5744 11.1334 9.92525 10.6026 9.38591C10.0719 8.84658 9.42697 8.57691 8.66797 8.57691C7.90897 8.57691 7.26408 8.84658 6.7333 9.38591C6.20252 9.92525 5.93714 10.5744 5.93714 11.3334V13.3334ZM8.66797 7.42325C9.42697 7.42325 10.0719 7.15358 10.6026 6.61425C11.1334 6.07491 11.3988 5.42575 11.3988 4.66675V2.66675H5.93714V4.66675C5.93714 5.42575 6.20252 6.07491 6.7333 6.61425C7.26408 7.15358 7.90897 7.42325 8.66797 7.42325ZM3.66797 14.3334V13.3334H4.9373V11.3334C4.9373 10.583 5.14264 9.89986 5.5533 9.28408C5.96397 8.66819 6.50819 8.24019 7.18597 8.00008C6.50819 7.75564 5.96397 7.32658 5.5533 6.71292C5.14264 6.09925 4.9373 5.41719 4.9373 4.66675V2.66675H3.66797V1.66675H13.668V2.66675H12.3986V4.66675C12.3986 5.41719 12.1933 6.09925 11.7826 6.71292C11.372 7.32658 10.8277 7.75564 10.15 8.00008C10.8277 8.24019 11.372 8.66819 11.7826 9.28408C12.1933 9.89986 12.3986 10.583 12.3986 11.3334V13.3334H13.668V14.3334H3.66797Z",
    style: {
      fill: "color(display-p3 0.9263 0.7102 0.0000)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/HourGlass.0779a8d21ab01cdd95f8b8f0c2dd8eab.svg";
export { ForwardRef as ReactComponent };